<ng-container *ngIf="isShowingResults === false">
  <textarea [ngStyle]="{'color': color}" [ngClass]="{disabled: isSubmitted}" [disabled]="isSubmitted"
            [(ngModel)]="text"></textarea>
  <app-card-button *ngIf="!isSubmitted"  [text]="'__INTERACTION_SUBMIT_RESPONSE__' | translate"  (onSubmit)="submit(text)"
    [ngClass]="{disabled: !isValid()}"
  ></app-card-button>
  <app-card-button *ngIf="isEnableSwitchViews && isSubmitted" (click)="showResults()"
                   [tightLayout]="true" [text]="'__INTERACTION_DISPLAY_STATISTICS__' | translate"
                   [color]="'rgba(168, 150, 246, 0.5)'" [colorInverse]="'white'"></app-card-button>
</ng-container>
<ng-container *ngIf="isShowingResults === true && phrases">
  <app-word-cloud [phrases]="phrases"></app-word-cloud>
  <app-card-button *ngIf="isEnableSwitchViews"
                   (click)="hideResults()"
                   [tightLayout]="true" [text]="'__INTERACTION_DISPLAY_MY_ANSWERS__' | translate"
                   [color]="'rgba(168, 150, 246, 0.5)'" [colorInverse]="'white'"></app-card-button>
</ng-container>
